import { Response } from "@/components/ai-elements/response";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";

type AnalysisPart = {
	id: string;
	original_text: string;
	description?: string;
	corrected_text?: string;
};

interface MistakeTextProps {
	analysisParts: AnalysisPart[];
	messageId: string;
}

export const MistakeText = ({ analysisParts, messageId }: MistakeTextProps) => {
	return (
		<>
			{analysisParts.map((analysisPart, i) => {
				if (analysisPart.id === "correct") {
					return (
						<Response
							className="inline [&:first-child]:ml-0 [&:last-child]:mr-0 mx-0.5 size-max [&>*]:inline"
							key={`${messageId}-${i}`}
						>
							{analysisPart.original_text}
						</Response>
					);
				}
				return (
					<HoverCard openDelay={100} key={`${messageId}-${i}`}>
						<HoverCardTrigger asChild className="size-max cursor-pointer inline">
							<Response className="mx-1 [&:first-child]:ml-0 [&:last-child]:mr-0 inline border-b-1 border-orange-500 hover:border-orange-800 transition-colors break-words whitespace-break-spaces [&>*]:inline decoration-slice">
								{analysisPart.original_text}
							</Response>
						</HoverCardTrigger>
						<HoverCardContent className="flex text-sm gap-2 flex-col w-max max-w-96">
							<div className="flex gap-1.5 text-muted-foreground">
								<div className="h-auto w-1 rounded-sm bg-orange-500" />
								{analysisPart.original_text}
							</div>
							<div>{analysisPart.description}</div>
							<div className="flex gap-2 flex-col">
								<span>Corrected:</span>
								<div className="flex gap-1.5 text-green-500">
									<div className="h-auto w-1 rounded-sm bg-green-500" />
									{analysisPart.corrected_text}
								</div>
							</div>
						</HoverCardContent>
					</HoverCard>
				);
			})}
		</>
	);
};

